/**
 * Mocked search data for preview/mocked flows.
 * Used when in mocked mode to show pre-populated search query and results.
 */

import type { SearchArticle } from '@/common/api/models.pleased';

export interface MockedSearchState {
  /** The search query text to pre-populate */
  searchQuery: string;
  /** The search results to display */
  searchResults: SearchArticle[];
  /** Whether to show the dropdown immediately */
  showDropdown: boolean;
}

/**
 * Create mocked search data with pre-populated query and results
 */
export const createMockedSearch = (): MockedSearchState => ({
  searchQuery: 'payment',
  searchResults: [
    {
      id: 1001,
      brandId: 1,
      sectionId: 1,
      categoryId: 2,
      categoryName: 'Payments',
      categoryNameTranslated: 'Payments',
      title: 'How to Make a Payment',
      titleTranslated: 'How to Make a Payment',
      position: 1,
      isDraft: false,
      isPromoted: false,
      isActive: true,
      language: 'en',
      englishVersion: true,
      updatedAt: new Date().toISOString(),
    },
    {
      id: 1002,
      brandId: 1,
      sectionId: 1,
      categoryId: 2,
      categoryName: 'Payments',
      categoryNameTranslated: 'Payments',
      title: 'Payment Failed - What to Do',
      titleTranslated: 'Payment Failed - What to Do',
      position: 2,
      isDraft: false,
      isPromoted: false,
      isActive: true,
      language: 'en',
      englishVersion: true,
      updatedAt: new Date().toISOString(),
    },
    {
      id: 1003,
      brandId: 1,
      sectionId: 1,
      categoryId: 2,
      categoryName: 'Payments',
      categoryNameTranslated: 'Payments',
      title: 'Payment Methods Accepted',
      titleTranslated: 'Payment Methods Accepted',
      position: 3,
      isDraft: false,
      isPromoted: false,
      isActive: true,
      language: 'en',
      englishVersion: true,
      updatedAt: new Date().toISOString(),
    },
    {
      id: 1004,
      brandId: 1,
      sectionId: 1,
      categoryId: 2,
      categoryName: 'Payments',
      categoryNameTranslated: 'Payments',
      title: 'Pending Payment Status',
      titleTranslated: 'Pending Payment Status',
      position: 4,
      isDraft: false,
      isPromoted: false,
      isActive: true,
      language: 'en',
      englishVersion: true,
      updatedAt: new Date().toISOString(),
    },
  ],
  showDropdown: true,
});
